import type { MarketVariants } from '@/lib/i18n'

export type Slide4WhyItWorksCopy = {
  quote: string
  attribution: string
  imageAlt: string
}

export const copy: MarketVariants<Slide4WhyItWorksCopy> = {
  US: {
    quote:
      "“The message felt real in the moment. It said my daughter was using a new number, needed money fast, and couldn't talk. I was about to send the money, then I thought: if this is real, I can check first. I called her on the number I already knew. She picked up, and everything was fine.”",
    attribution: 'Elaine, mother targeted by a family emergency scam',
    imageAlt: 'Elaine',
  },
  // QA: Elaine keeps her name, a photo ties to it.
  ar: {
    quote:
      '"بدت الرسالة حقيقية في تلك اللحظة. قالت إن ابنتي تستخدم رقماً جديداً، وتحتاج إلى المال بسرعة، ولا تستطيع التحدث. كنت على وشك إرسال المال، ثم فكّرت: إن كان هذا حقيقياً، فبإمكاني التحقق أولاً. اتصلت بها على الرقم الذي أعرفه. ردّت عليّ، وكان كل شيء على ما يرام."',
    attribution: 'إيلين، أم استُهدفت بعملية احتيال بذريعة حالة طارئة عائلية',
    imageAlt: 'إيلين',
  },
}
